export default {
	search: {
		title: 'Vyhledávání',
		text:
			'Umožňuje vyhledávat ve sčítacích operátech a rejstřících podle vybraných kritérií.',
	},
	help: {
		title: 'Nápověda',
		text: 'Často kladené otázky k vyhledávání a funkcím Digitálního archivu.',
	},
	contact: {
		title: 'Kontakt',
		text:
			'Kontaktní údaje na Archiv města Brna a formulář k případným dotazům badatelů.',
	},
};
